module.exports = __webpack_public_path__ + "static/Manrope-Regular-0b726174d2b7e161b9e5e8125bf7751a.ttf";